export const tabMap: Record<string, string> = {
    is_user_bot_source: 'monitoring',
    is_chat_bot_source: 'manage',
};
